import { useLocation } from 'react-router-dom';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { formatDate } from 'components/widgets/FinishDateOverallSummary/FinishDateOverallSummary.utils';

export const useFinishDateOverallSummaryLogic = ({ api, setIsPayloadReady, widgetViewMode }) => {
    const isPayloadReady = () => {
        const currentPayload = api.getActivityPrediction.payload;
        if (!currentPayload) return;
        if (currentPayload.versionId === undefined || currentPayload.hashCode === undefined) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    const { pathname } = useLocation();
    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });
    const activityPredictionData = api.getActivityPrediction.instance.data;

    const isActivityDone = activityPredictionData?.status?.name === 'DONE';

    const plannedFinishDate = formatDate(activityPredictionData?.planedFinishDate);
    const optimisticForecastedData = isActivityDone ? 'Done' : formatDate(activityPredictionData?.optimisticFinishDate);
    const bestForecastedData = isActivityDone ? 'Done' : formatDate(activityPredictionData?.bestFinishDate);
    const pessimisticForecasted = isActivityDone ? 'Done' : formatDate(activityPredictionData?.pessimisticsFinishDate);
    const baselineFinishDate = formatDate(activityPredictionData?.baselineFinishDate);

    return {
        logic: {
            pathname,
            plannedFinishDate,
            optimisticForecastedData,
            bestForecastedData,
            pessimisticForecasted,
            baselineFinishDate,
        },
    };
};
